import axios from 'axios'
import store from '@/store'
import router from '@/router'
import CSRF from '@/services/csrf'
import { errorToast } from '@/services/toastify'

/**
 *   Get the axios API client.
 *   This conveniently sets the `baseURL` and `headers` for the API client,
 *   so that we don't have to do this in every function that needs to call
 *   the API.
 *   This will automaticaly proxy requrests to /api/
 *   if the /api/ route is already included the vue.config.js will overwrite it
 *
 *
 *   @returns {object} - An instance of the axios API client.
 */

class ApiService {
  static session
  static init
  constructor() {
    let baseURL = `${window.location.protocol}//${window.location.host}/api`

    console.debug(`API Service for ${baseURL}`)

    ApiService.session = axios.create({
      baseURL,
      headers: {
        ...CSRF.getHeaders(),
      },
    })
    // https://www.npmjs.com/package/axios#interceptors
    ApiService.session.interceptors.request.use(
      async (config) => {
        if (store.getters.isLoggedIn) {
          config.headers['Authorization'] = `Token ${store.getters.token}`
        }
        return config
      },
      (error) => {
        Promise.reject(error)
      },
    )
    ApiService.session.interceptors.response.use(
      (response) => response,
      async function (error) {
        // in this app, there are no permission tiers
        // if 401, then the only reason is invalid token
        if (error.response.status === 401) {
          errorToast(`Session expired, please login.`)
          await store.dispatch('setUser', null)
          router.push({ name: 'Login' })
        }
        return Promise.reject(error)
      },
    )
  }

  static get instance() {
    if (!ApiService.init) {
      new ApiService()
      ApiService.init = true
    }
    return ApiService.session
  }
}

export default ApiService.instance
// extend and use
export { ApiService }
